import { LatLng, MapAddress } from "@ehealth_tools/common-map/src/map.definitions";

/**
 * Retrieve the location (latitude + longitude) from a given address
 * @param address Address of the marker as string
 * @returns 
 */
export function geocodeAddress(address: string): Promise<google.maps.LatLng> {
    const geocoder = new google.maps.Geocoder();
    return new Promise((resolve, reject) => {
        geocoder.geocode({
            address: address
        }, (results, status) => {
            if (status === google.maps.GeocoderStatus.OK && results != null) {
                resolve(results[0].geometry.location);
            } else {
                reject(new Error(`Geocode failed for address "${address}" with status: ${status}`));
            }
        });
    });
}

/** Get Google Maps Address from lat/lng or plain address if needed */
export async function getGoogleAddress(address: MapAddress, saveLocation?: (dto: MapAddress, localization: LatLng) => Promise<void>): Promise<google.maps.LatLng> {
    if (address.lat && address.lng) {
        return Promise.resolve(new google.maps.LatLng({ lat: address.lat, lng: address.lng }));
    }
    const latLng = await geocodeAddress(addressToPlainAddress(address));
    // Store the result in the object so we do not have to recall google each time
    if (saveLocation) {
        // Prefer to SAVE these data to safe money
        saveLocation(address, { lat: latLng.lat(), lng: latLng.lng() });
    } else {
        address.lat = latLng.lat();
        address.lng = latLng.lng();
    }

    return latLng;
}

/** Export MapAddress object as a string */
export function addressToPlainAddress(address: MapAddress): string {
    return `${address.address}, ${address.postalCode} ${address.city}`;
}